const daycareApiHost = process.env.REACT_APP_DAYCARE_API_HOST;
const daycareApiVersion = process.env.REACT_APP_DAYCARE_API_VERSION;

const daycareApiRoot = "https://" + daycareApiHost + "/v" +  daycareApiVersion;

export {
  daycareApiRoot,
}




// WEBPACK FOOTER //
// ./src/constants/API.js